import React from 'react'


const Navbar = () => {
  return (
    <header>
      <div>millamzy</div>
      <div><a href='/'>Home</a></div>
    </header>
  )
}

export default Navbar
